import { Component } from '@angular/core';
import { TermsStorage } from './terms-storage';

@Component({
    selector: 'osr-disclaimer',
    template: require('./osr-disclaimer.component.html'),
    styles: [require('./osr-disclaimer.component.scss')]
})
export class OsrDisclaimerComponent {
    public osrDisclaimerText: Promise<string>;

    constructor(termsStorage: TermsStorage) {
        this.osrDisclaimerText = termsStorage.osrDisclaimerText;
    }
}